// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2fOvh","empty":"ModalGraph_empty__1Mw2t"};